import { Avatar, ButtonBase, Stack, Typography } from '@mui/material';
import { MouseEventHandler, PropsWithChildren } from 'react';
import { Tooltip } from '../../../sprouts/components/Tooltip/Tooltip';
import { NavIcon } from './NavIcon';

interface NavbarIconButtonProps extends PropsWithChildren {
  label?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  active?: boolean;
  customIcon?: boolean;
}

/**
 * Navbar button with active/inactive color scheme
 *
 * This is designed to take in an svg (see NavIcon) as its child,
 * but any component can be provided by setting customIcon = true
 */
export const NavbarIconButtonWithLabel = ({
  label = '',
  onClick,
  active = false,
  customIcon = false,
  children,
}: NavbarIconButtonProps) => {
  return (
    <Tooltip title={label} placement='right'>
      <ButtonBase
        onClick={onClick ?? undefined}
        disableRipple
        sx={{ justifyContent: 'flex-start', width: '100%' }}
      >
        <Stack direction='row' alignItems='center' spacing={1}>
          <Avatar
            sx={(theme) => ({
              borderRadius: 1,
              width: 24,
              height: 24,
              padding: '1rem',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: theme.vars.palette.action.hover,
              },
            })}
          >
            {customIcon ? (
              children
            ) : (
              <NavIcon color={active ? 'primary' : 'secondary'}>
                {children}
              </NavIcon>
            )}
          </Avatar>

          {label && (
            <Typography
              noWrap
              fontWeight={500}
              fontSize='0.875rem'
              sx={{
                color: (theme) =>
                  active
                    ? theme.vars.palette.primary.main
                    : theme.vars.palette.text.secondary,
              }}
            >
              {label}
            </Typography>
          )}
        </Stack>
      </ButtonBase>
    </Tooltip>
  );
};
